export const handleToastFocus = () => {
  const [toast] = document.getElementsByClassName("toast")

  if (toast) {
    toast.setAttribute("aria-live", "polite")
    toast.setAttribute("role", "alert")
  }
}